<template>
	<div
		class="admin-dashboard-plugins-common-Grid"
		:style="[rows && rows.length == 0 ? {'opacity': '0'} : {}]"
	>

		<vue-ads-table-tree
			ref="table"
			v-if="rows"
			:columns="columns"
			:rows="rows"
			:filter="filter"
			:page="page"
			:items-per-page="10"
			@filter-change="filterChanged"
			@page-change="pageChanged"
		>
			<template slot="no-rows">Geen resultaten</template>

			<!-- @ugly Having column specific slots here while the parent should provide it. -->
			<template
					slot="account_name"
					slot-scope="props">
				{{ props.row.account_name }}

				<img
						v-if="props.row.is_ero"
						class="inline-block w-4 -mt-1"
						src="/img/ero.svg" />

			</template>

			<template slot="total_minutes" slot-scope="props">{{ props.row.total_minutes }}</template>

			<template slot="averageAcceptedDuration" slot-scope="props">{{ getFormattedMinutes(props.row.averageAcceptedDuration) }}</template>

			<template slot="score" slot-scope="props">{{ getFormattedScore(props.row) }}</template>

		</vue-ads-table-tree>

	</div>

</template>

<script>
import VueAdsTableTree from 'vue-ads-table-tree';
import 'vue-ads-table-tree/dist/vue-ads-table-tree.css'

export default {
	name: 'grid',
	components: {
		'vue-ads-table-tree': VueAdsTableTree,
	},

	props: {
		rows: Array,
		columns: Array
	},

	data: function () {
		return {
			filter: "",
			page: 0,
		}
	},

	async mounted()
	{
	},

	methods: {

		// @ugly Custom formatter as method in this component.
		getFormattedTotalHours(value)
		{
			let hours = Math.round(value / 60 * 4) / 4;
			let flooredHours = Math.floor(hours);
			let rest = hours % 1;

			if(rest >= .75)
				return flooredHours + ':45';

			else if(rest >= .5)
				return flooredHours + ':30';

			else if(rest >= .25)
				return flooredHours + ':15';

			else
				return flooredHours + ':00';
		},

		// @ugly Custom formatter as method in this component.
		getFormattedMinutes(value)
		{
			let hours = Math.floor(value / 60 / 60);
			let minutes = Math.floor(value / 60) % 60;
			let seconds = Math.floor(value % 60);

			return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
		},

		// @ugly Custom formatter as method in this component.
		getFormattedScore(row)
		{
			return Math.round(row.amountOfAccepted / row.amountOfEntries * 100) + '%';
		},

		filterChanged(filter) {
			this.filter = filter;
		},

		pageChanged(page) {
			this.page = page;
		},
	},

}
</script>

<style lang="scss">

	.admin-dashboard-plugins-common-Grid {

		th:nth-child(2) {
			width: 130px;
		}

		.fa-sort {
			position: relative;
			top: 4px;
		}

		.vue-ads-bg-teal-500 {
			background: #057c77 !important;
		}

		table + div {
			margin: 15px 0 -5px 0 !important;;

			// Hide pagination since we cannot translate it.
			.vue-ads-pr-2.vue-ads-leading-loose {
				display: none;
			}

			button {
				padding: 7px 15px !important;
				width: auto !important;

				&[disabled] {
					display: none !important;
				}
			}

		}

	}

</style>
